import { LOADING, ADD_NOTIFICATION, SHOW_CART_NOTIFICATION, CLOSE_CART_NOTIFICATiON, SHOW_LOGIN, SET_AUTH_POPUP_PANEL, SHOW_RESPONSIVE_MENU, MAIN_LOCK_SCROLL, WEB_STATUS, WEB_STATUS_ERR, DISPLAY_SHARE_POPUP, SET_MAINTENANCE, SHOW_EVENT_POPUP, SHOW_ROYAL_POPUP, SET_EID, AUTH_PENDING } from '../actions/common/type';
import { DETECT_WARNING_MACHINE } from '../actions/auth/type';
import { STATUS } from '../config';
import { isServer } from '../store';
const initState = {
    status: STATUS.ONLINE,
    statusLoading: true, // Add loading state for status check
    text: null,
    type: null,
    loading: false,
    count: 0,
    notification: null,
    cart_notify: false,
    cart_latest_item: null,
    show_login: false,
    authPopupPanel: 'login',
    show_responsive_menu: false,
    lock_scroll: false,
    suspicious: false,
    maintenance: false,
    event_popup: false,
    royal_popup: false,
    eid: '',
    // Which auth control is in flight: 'facebook' | 'google' | 'apple' | 'email' | null.
    // Deliberately a single value, not one flag per button - see actions/common/index.js.
    authPending: null
};
export default function (state = initState, action) {
    switch (action.type) {
        case LOADING:
            let n = state.count;
            if (action.payload) {
                n++;
            } else {
                n--;
            }
            return { ...state, count: !isServer ? n : 0, loading: !isServer ? n > 0 : false };
        case ADD_NOTIFICATION:
            const notification = action.payload;
            if (notification) {
                notification.autoDismiss = 3;
                notification.position = "tr";
            }
            return { ...state, notification: notification };

        case SHOW_CART_NOTIFICATION:
            return { ...state, cart_notify: true, cart_latest_item: action.payload };

        case CLOSE_CART_NOTIFICATiON:
            return { ...state, cart_notify: false };
        case SHOW_LOGIN:
            return { ...state, show_login: action.payload.visible, authPopupPanel: action.payload.panel };
        case AUTH_PENDING:
            return { ...state, authPending: action.payload };
        case SET_AUTH_POPUP_PANEL:
            return { ...state, authPopupPanel: action.payload };
        case SHOW_RESPONSIVE_MENU:
            return { ...state, show_responsive_menu: action.payload };
        case MAIN_LOCK_SCROLL:
            return { ...state, lock_scroll: action.payload }
        case DETECT_WARNING_MACHINE:
            return { ...state, suspicious: action.payload }
        case WEB_STATUS:
            return { ...state, ...action.payload, statusLoading: false };
        case WEB_STATUS_ERR:
            return { ...state, status: STATUS.OFFLINE, statusLoading: false }
        case DISPLAY_SHARE_POPUP:
            return { ...state, display_share_popup: action.payload };
        case SET_MAINTENANCE:
            return { ...state, status: action.payload, statusLoading: false };
        case SHOW_EVENT_POPUP:
            return { ...state, event_popup: action.payload };
        case SHOW_ROYAL_POPUP:
            return { ...state, royal_popup: action.payload };
        case SET_EID:
            return { ...state, eid: action.payload };
        default:
            return state;
    }
}